import React from 'react'

export default function IconClone({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
        >
            <g clipPath='url(#clip0_2369_35405)'>
                <path d='M10 8V12' stroke={color} strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M8 10H12' stroke={color} strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
                <path
                    d='M13.333 5.33337H6.66634C5.92996 5.33337 5.33301 5.93033 5.33301 6.66671V13.3334C5.33301 14.0698 5.92996 14.6667 6.66634 14.6667H13.333C14.0694 14.6667 14.6663 14.0698 14.6663 13.3334V6.66671C14.6663 5.93033 14.0694 5.33337 13.333 5.33337Z'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M2.66634 10.6667C1.93301 10.6667 1.33301 10.0667 1.33301 9.33337V2.66671C1.33301 1.93337 1.93301 1.33337 2.66634 1.33337H9.33301C10.0663 1.33337 10.6663 1.93337 10.6663 2.66671'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_2369_35405'>
                    <rect width='16' height='16' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}
